import { cn } from '@/lib/utils';
import { formatStatus } from '@/lib/formatters';

export interface StatusBadgeProps {
  status: 'open' | 'closed' | 'partial';
  size?: 'sm' | 'md';
  className?: string;
}

const statusColors: Record<string, string> = {
  open: 'bg-green-100 text-green-700',
  closed: 'bg-gray-100 text-gray-700',
  partial: 'bg-yellow-100 text-yellow-700',
};

export function StatusBadge({ status, size = 'md', className }: StatusBadgeProps) {
  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-xs',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center font-medium rounded-full',
        statusColors[status] || 'bg-gray-100 text-gray-700',
        sizes[size],
        className
      )}
    >
      {formatStatus(status)}
    </span>
  );
}

export interface SyncStatusBadgeProps {
  status: 'pending' | 'running' | 'completed' | 'failed';
  className?: string;
}

const syncStatusColors: Record<string, string> = {
  pending: 'bg-yellow-100 text-yellow-700',
  running: 'bg-blue-100 text-blue-700',
  completed: 'bg-green-100 text-green-700',
  failed: 'bg-red-100 text-red-700',
};

export function SyncStatusBadge({ status, className }: SyncStatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-1 text-xs font-medium rounded-full',
        syncStatusColors[status] || 'bg-gray-100 text-gray-700',
        className
      )}
    >
      {status === 'running' && (
        <svg className="animate-spin -ml-0.5 mr-1.5 h-3 w-3" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
}
